module.exports = __webpack_public_path__ + "static/media/klatre-t.243ee7b5.mp3";